import { useCallback } from 'react';
import { trpc } from '../apiCalls/trpcClient';
import { UserVisit } from '@sapphicsavvy/business';

function useTracker() {
    const { mutate: trackVisit } = trpc.user.trackVisit.useMutation();

    const withTrack = useCallback(
        <T, P>(visit: UserVisit, func?: (...args: T[]) => P) => {
            function handler(...args: T[]) {
                trackVisit(
                    {
                        visit,
                    },
                    {
                        onSuccess: () => {
                            console.log('Visit tracked successfully:', visit);
                        },
                        onError: () => {
                            console.warn('Error tracking visit:', visit);
                        },
                    },
                );
                return func?.(...args);
            }
            return handler as T extends never ? () => P : (...args: T[]) => P;
        },
        [trackVisit],
    );

    const track = useCallback(
        (visit: UserVisit) => {
            withTrack(visit)();
        },
        [withTrack],
    );

    return { withTrack, track };
}

export { useTracker };
